import { notification } from "antd";
import { NotificationType } from "../types/AllTypes";
import saveAs from "file-saver";
import * as XLSX from "xlsx";
import { ISelectOption } from "../../interfaces/ISelectOption";
import { IForm, IFormQuestion } from "../../interfaces/IForm";
import { IListBase } from "../../interfaces/IListado";
import { IUserInformation } from "../../interfaces/IUser";
import { PreguntaTipo } from "../enums/AllEnums";


export const openNotification = (type: NotificationType, title: string, message: string) => {
    notification[type]({
        message: title,
        description: message
    });
};

export const tryCatch = (method: any) => {
    try {
        method();
    } catch (error) {
        openNotification('error', `Error Interno`, `Contáctese con el equipo Bis para más información. ${error}`);
    }
}

export const validateEmail = (email: string): boolean => {
    let regrex = /^(([^<>()\[\]\\.,;:\s@”]+(\.[^<>()\[\]\\.,;:\s@”]+)*)|(“.+”))@((\[[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}])|(([a-zA-Z\-0–9]+\.)+[a-zA-Z]{2,}))$/;
    return !regrex.test(email);
}

export const getFile = (sheet: any) => {
    var excel = XLSX.utils.book_new();
    excel.Props = {
        Title: "Bisformulario List",
        Subject: "List",
        Author: "BisFormularioWeb",
        CreatedDate: new Date()
    };
    excel.SheetNames.push("Sheet1");

    excel.Sheets["Sheet1"] = sheet;
    var wbout = XLSX.write(excel, { bookType: 'xlsx', type: 'binary' });
    saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), 'Listado.xlsx');
}

const s2ab = (s: any) => {
    var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
    var view = new Uint8Array(buf);  //create uint8array as viewer
    for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
    return buf;
}


export const hasNumber = (value?: string) => {
    if (!!value) {
        const regrexValidation = /[0-9]/;
        if (regrexValidation.test(value)) {
            return true;
        }
    }
    return false;
}

export const hasUpperChar = (value?: string) => {
    if (!!value) {
        const regrexValidation = /[A-Z]/;
        if (regrexValidation.test(value)) {
            return true;
        }
    }
    return false;
}

export const hasLowerChar = (value?: string) => {
    if (!!value) {
        const regrexValidation = /[a-z]/;
        if (regrexValidation.test(value)) {
            return true;
        }
    }
    return false;
}

export const hasSymbols = (value?: string) => {
    if (!!value) {
        const regrexValidation = /[!@#$%^&*()_+=\[{\]};:<>|./?,-]/;
        if (regrexValidation.test(value)) {
            return true;
        }
    }
    return false;
}


export const returnOrdenSelection = (orden: string, listOption?: any[] | null): any[] => {
    if (!!listOption) {
        let ordenList: ISelectOption[] = [];

        let length: number = (listOption.length < 1) ? 0 : Math.max(...(listOption?.map(x => x.orden)!)) + 1;

        for (let index = 0; index <= length; index++) {
            const element: ISelectOption = { key: index.toString() + "order", value: (index + 1).toString(), text: (index + 1).toString() };
            ordenList.push(element);
        }

        return ordenList.filter(x => !listOption.map(y => y.orden)?.includes(parseInt(x.value)) || x.value === orden);
    } else {
        return [];
    }
}


export const makeTextPlain = (text: string) => {
    return text.trim().split(" ").join("").toLowerCase();
}

export const canFormQuestionGoNext = (form: IForm) => {
    let canGo = true;

    form?.pregunta?.forEach(element => {
        if (questionHasError(element)) {
            canGo = false;
        }
    });

    return canGo;
}

export const questionHasError = (question: IFormQuestion) => {

    if (!question.pregunta || !question.preguntaTipoNombre) {
        return true;
    }

    if ((!!question.query && !question.frecuenciaActualizacionID) || (!question.query && !!question.frecuenciaActualizacionID)) {
        return true;
    }

    if (question.preguntaTipoNombre === PreguntaTipo.Numerico && !!question.valorMaximo && !!question.valorMinimo && parseFloat(question.valorMaximo) < parseFloat(question.valorMinimo)) {
        return true;
    }

    if ((question.preguntaTipoNombre === PreguntaTipo.Fecha || question.preguntaTipoNombre === PreguntaTipo.FechaHora || question.preguntaTipoNombre === PreguntaTipo.FechaRango || question.preguntaTipoNombre === PreguntaTipo.FechaRangoMultiple) && !!question.valorMaximo && !!question.valorMinimo && new Date(question.valorMaximo!).getTime() < new Date(question.valorMinimo!).getTime()) {
        return true;
    }

    if (question.preguntaTipoNombre === PreguntaTipo.Hora && !!question.valorMaximo && !!question.valorMinimo && new Date(`${new Date().toDateString()} ${question.valorMaximo}`).getTime() < new Date(`${new Date().toDateString()} ${question.valorMinimo}`).getTime()) {
        return true;
    }

    if ((!!question.atributoNombre1 && !question.atributoValor1) || (!question.atributoNombre1 && !!question.atributoValor1)) {
        return true;
    }
    if ((!!question.atributoNombre2 && !question.atributoValor2) || (!question.atributoNombre2 && !!question.atributoValor2)) {
        return true;
    }
    if ((!!question.atributoNombre3 && !question.atributoValor3) || (!question.atributoNombre3 && !!question.atributoValor3)) {
        return true;
    }

    return false;
}

export const getCopyOf = (object: any) => {
    return JSON.parse(JSON.stringify(object));
}

export const getError = (errorMessage: string | null) => {
    return !!errorMessage ? errorMessage : 'Contáctese con el equipo Bis para más información.';
}

export const initialFormQuestion: IFormQuestion = {
    preguntaID: 0,
    formularioID: 0,
    formularioGrupoPreguntaID: 0,
    grupoPreguntaID: 0,
    pregunta: '',
    preguntaTipo:  null,
    preguntaTipoNombre: '',
    esPrincipal: false,
    esObligatoria: true,
    valorMinimo: null,
    valorMaximo: null,
    orden: 0,
    respuestaOpcionTipo: 1,
    respuestaOpcionTipoNombre: '',
    query: null,
    frecuenciaActualizacionID: 1,
    atributoNombre1: null,
    atributoValor1: null,
    atributoNombre2: null,
    atributoValor2: null,
    atributoNombre3: null,
    atributoValor3: null,
    respuestaOpcion: [{
        respuestaOpcionID: 0,
        preguntaID: 0,
        preguntaSiguienteID: null,
        respuesta: null,
        resultado: null,
        orden: 0
    }]
};
export const fakeFormQuestion: IForm = {
    formularioID: 0,
    departamentoGUID: '',
    usuarioModificoGUID: null,
    nombre: '',
    esFormularioSecuencial: false,
    visualizacionTipo: undefined,
    visualizacionTipoNombre: null,
    distancia: 0,
    cantidadDiasHistorico: 0,
    bloquearPaginacion: false,
    cantidadRegistro: 10,
    cantidadMaximaLlenado: 0,
    cantidadMaximaLlenadoDia: 0,
    diaSemana: '0000000',
    fechaDesde: null,
    fechaHasta: null,
    formularioEstadoTipo: undefined,
    formularioEstadoTipoNombre: null,
    listadoNombre: null,
    bloquearListado: false,
    formularioDetalle: [],
    formularioGrupoPregunta: [],
    pregunta: [initialFormQuestion],
    mostrarListadoDisponible: true
}

export const fakeListBase: IListBase = {
    listadoID: 0,
    departamentoGUID: "",
    UsuarioModificoGUID: null,
    nombre: "",
    listadoTipo: 1,
    listadoTipoNombre: "",
    query: null,
    frecuenciaActualizacionID: null,
    fechaUltimaActualizacion: null,
    fechaProximaActualizacion: null,
    listadoAtributo: [],
    listadoDetalle: []
}


export const fakeUser: IUserInformation = {
    cedula: "",
    codigoEmpleado: "",
    correo: "",
    fotoPerfil: null,
    nombreUsuario: "",
    primerApellido: "",
    primerNombre: "",
    segundoApellido: null,
    segundoNombre: null,
    sexoTipo: null,
    sexoTipoNombre: "Masculino",
    usuarioAtributo: [],
    usuarioGUID: "",
    usuarioID: 0,
    usuarioModificoID: 0,
    usuarioProyecto: {
        clave: "",
        departamentoGUID: "",
        departamentoID: 0,
        departamentoNombre: "",
        esAdministrador: false,
        fechaDesde: null,
        fechaHasta: null,
        puestoID: 0,
        puestoNombre: "",
        usuarioID: 0,
        usuarioProyectoID: 0,
        usuarioProyectoRol: [],
        //
        confirmClave: "",
        temporal: 'false'
        //
    },
}

